import {
  ResponsiveContainer,
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { cn } from "../../lib/utils";

type AreaChartProps<T extends { label: string; value: number }> = {
  data: T[];
  className?: string;
};

const CustomAreaChart = <T extends { label: string; value: number }>({
  data,
  className,
}: AreaChartProps<T>) => {
  return (
    <div className={cn("w-full h-[400px]", className)}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsAreaChart data={data}>
          <defs>
            <linearGradient id="areaGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="15%" stopColor="#1783ff" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#d6e9ff" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />

          <XAxis dataKey="label" stroke="#94a3b8" fontSize={12} interval={0} />

          <YAxis stroke="#94a3b8" fontSize={12} />

          <Tooltip
            contentStyle={{
              backgroundColor: "white",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              padding: "8px 12px",
              fontSize: "12px",
            }}
            labelStyle={{ color: "#334155" }}
            itemStyle={{ color: "#0373fc" }}
          />

          <Area
            type="monotone"
            dataKey="value"
            stroke="#0373fc"
            strokeWidth={2}
            fill="url(#areaGradient)"
          />
        </RechartsAreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomAreaChart;
